"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_query_operation_1 = require("@comunica/bus-query-operation");

var bus_rdf_join_1 = require("@comunica/bus-rdf-join");

var sparqlee_1 = require("sparqlee");
/**
 * A comunica LeftJoin NestedLoop Query Operation Actor.
 */


var ActorQueryOperationLeftJoinNestedLoop =
/*#__PURE__*/
function (_bus_query_operation_) {
  _inherits(ActorQueryOperationLeftJoinNestedLoop, _bus_query_operation_);

  function ActorQueryOperationLeftJoinNestedLoop(args) {
    _classCallCheck(this, ActorQueryOperationLeftJoinNestedLoop);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationLeftJoinNestedLoop).call(this, args, 'leftjoin'));
  }

  _createClass(ActorQueryOperationLeftJoinNestedLoop, [{
    key: "testOperation",
    value: function () {
      var _testOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(pattern, context) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", true);

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function testOperation(_x, _x2) {
        return _testOperation.apply(this, arguments);
      }

      return testOperation;
    }()
  }, {
    key: "runOperation",
    value: function () {
      var _runOperation = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(pattern, context) {
        var leftRaw, left, rightRaw, right, config, evaluator, leftJoinInner, leftJoinOuter, transform, bindingsStream, variables, metadata;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.left,
                  context: context
                });

              case 2:
                leftRaw = _context4.sent;
                left = bus_query_operation_1.ActorQueryOperation.getSafeBindings(leftRaw);
                _context4.next = 6;
                return this.mediatorQueryOperation.mediate({
                  operation: pattern.right,
                  context: context
                });

              case 6:
                rightRaw = _context4.sent;
                right = bus_query_operation_1.ActorQueryOperation.getSafeBindings(rightRaw);
                config = Object.assign({}, bus_query_operation_1.ActorQueryOperation.getExpressionContext(context));
                evaluator = pattern.expression ? new sparqlee_1.AsyncEvaluator(pattern.expression, config) : null;

                leftJoinInner = function leftJoinInner(outerItem, innerStream) {
                  var joinedStream = innerStream.transform({
                    transform: function () {
                      var _transform = _asyncToGenerator(
                      /*#__PURE__*/
                      _regeneratorRuntime.mark(function _callee2(innerItem, nextInner) {
                        var joinedBindings, result;
                        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                          while (1) {
                            switch (_context2.prev = _context2.next) {
                              case 0:
                                joinedBindings = bus_rdf_join_1.ActorRdfJoin.join(outerItem, innerItem);

                                if (joinedBindings) {
                                  _context2.next = 4;
                                  break;
                                }

                                nextInner();
                                return _context2.abrupt("return");

                              case 4:
                                if (pattern.expression) {
                                  _context2.next = 8;
                                  break;
                                }

                                joinedStream._push({
                                  joinedBindings: joinedBindings,
                                  result: true
                                });

                                nextInner();
                                return _context2.abrupt("return");

                              case 8:
                                _context2.prev = 8;
                                _context2.next = 11;
                                return evaluator.evaluateAsEBV(joinedBindings);

                              case 11:
                                result = _context2.sent;

                                joinedStream._push({
                                  joinedBindings: joinedBindings,
                                  result: result
                                });

                                _context2.next = 18;
                                break;

                              case 15:
                                _context2.prev = 15;
                                _context2.t0 = _context2["catch"](8);

                                if (!sparqlee_1.isExpressionError(_context2.t0)) {
                                  bindingsStream.emit('error', _context2.t0);
                                }

                              case 18:
                                nextInner();

                              case 19:
                              case "end":
                                return _context2.stop();
                            }
                          }
                        }, _callee2, null, [[8, 15]]);
                      }));

                      function transform(_x5, _x6) {
                        return _transform.apply(this, arguments);
                      }

                      return transform;
                    }()
                  });
                  return joinedStream;
                };

                leftJoinOuter = function leftJoinOuter(leftItem, nextLeft) {
                  var innerStream = right.bindingsStream.clone();
                  var joinedStream = leftJoinInner(leftItem, innerStream); // TODO: This will not work for larger streams.
                  // The full inner stream is kept in memory.

                  joinedStream.on('end', function () {
                    return nextLeft();
                  });
                  joinedStream.on('data',
                  /*#__PURE__*/
                  function () {
                    var _ref2 = _asyncToGenerator(
                    /*#__PURE__*/
                    _regeneratorRuntime.mark(function _callee3(_ref) {
                      var joinedBindings, result;
                      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                          switch (_context3.prev = _context3.next) {
                            case 0:
                              joinedBindings = _ref.joinedBindings, result = _ref.result;

                              if (result) {
                                bindingsStream._push(joinedBindings);
                              }

                            case 2:
                            case "end":
                              return _context3.stop();
                          }
                        }
                      }, _callee3);
                    }));

                    return function (_x7) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                };

                transform = leftJoinOuter;
                bindingsStream = left.bindingsStream.transform({
                  optional: true,
                  transform: transform
                });
                variables = bus_rdf_join_1.ActorRdfJoin.joinVariables({
                  entries: [left, right]
                });

                metadata = function metadata() {
                  return Promise.all([left, right].map(function (entry) {
                    return entry.metadata();
                  })).then(function (metadatas) {
                    return metadatas.reduce(function (acc, val) {
                      return acc * val.totalItems;
                    }, 1);
                  }).catch(function () {
                    return Infinity;
                  }).then(function (totalItems) {
                    return {
                      totalItems: totalItems
                    };
                  });
                };

                return _context4.abrupt("return", {
                  type: 'bindings',
                  bindingsStream: bindingsStream,
                  metadata: metadata,
                  variables: variables
                });

              case 17:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function runOperation(_x3, _x4) {
        return _runOperation.apply(this, arguments);
      }

      return runOperation;
    }()
  }]);

  return ActorQueryOperationLeftJoinNestedLoop;
}(bus_query_operation_1.ActorQueryOperationTypedMediated);

exports.ActorQueryOperationLeftJoinNestedLoop = ActorQueryOperationLeftJoinNestedLoop;